import { render, staticRenderFns } from "./import.dialog.vue?vue&type=template&id=596d25e0&"
import script from "./import.dialog.vue?vue&type=script&lang=js&"
export * from "./import.dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports